/* MELYSIUM: Bundles ohne Rapi (Bau 01.11.2026, Test-Theme "TEST Bundles ohne Rapi").
   Zwei Teile:
   1. Kaufbox (snippets/mlys-bundles.liquid): faengt das Absenden des Produktformulars ab und
      legt die gewaehlte Karte in den Warenkorb. Staffel = Einzelzeilen je Duft plus
      Geschenk-Zeilen, Kombi/Set = eine Bundle-Variante (Geschenk steckt als Bestandteil drin).
   2. Geschenk-Abgleich im Warenkorb (ueberall): zaehlt Stueck je Produkt, nimmt pro Produkt die
      hoechste erreichte Stufe aus window.mlysBundleRegeln und gleicht die 0-EUR-Geschenkzeilen
      in beide Richtungen ab (fehlt = rein, zu viel = raus). Duft/Groesse einer vorhandenen
      Geschenkzeile bleibt erhalten. Rabatte rechnet Shopify selbst (Automatikrabatte mlys-staffel).
   Laeuft neben assets/mlys-gratis-beutel.js (Warenkorbwert-Geschenke), beide fassen nur ihre
   eigenen Varianten an. */
(function () {
  var R = window.mlysBundleRegeln || {};
  var GESCHENKE = R.geschenke || {};
  var REGELN = R.regeln || {};
  var geschenkVon = {};
  Object.keys(GESCHENKE).forEach(function (k) {
    (GESCHENKE[k].v || []).forEach(function (v) { geschenkVon[v] = k; });
  });

  var holen = window.fetch.bind(window);
  var laeuft = false, nochmal = false;

  function sectionIds() {
    var d = document.querySelector('cart-drawer');
    try { if (d && d.getSectionsToRender) return d.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function post(pfad, daten, mitSections) {
    if (mitSections) { daten.sections = sectionIds().join(','); daten.sections_url = window.location.pathname; }
    return holen(pfad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Mlys-Bundles': '1' },
      body: JSON.stringify(daten)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) j.status = j.status || r.status; return j; }); });
  }

  /* Drawer still neu zeichnen (wie mlys-gratis-beutel.js), offen=true oeffnet ihn danach */
  function zeichnen(antwort, offen) {
    if (window.location.pathname.indexOf('/cart') === 0) { window.location.reload(); return; }
    if (!antwort || !antwort.sections) return;
    var los = function () {
      var d = document.querySelector('cart-drawer');
      if (!d || !d.getSectionsToRender) return;
      if (offen && d.renderContents) { d.classList.remove('is-empty'); d.renderContents(antwort); return; }
      d.getSectionsToRender().forEach(function (s) {
        var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
        if (el && antwort.sections[s.id]) el.innerHTML = d.getSectionInnerHTML(antwort.sections[s.id], s.selector);
      });
      d.classList.toggle('is-empty', !document.querySelector('#CartDrawer tr.cart-item'));
      var ov = document.querySelector('#CartDrawer-Overlay');
      if (ov && d.close) ov.addEventListener('click', d.close.bind(d));
    };
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(los); else los();
  }

  /* ---------- 2. Geschenk-Abgleich ---------- */
  function sollGeschenke(items) {
    var stueck = {};
    items.forEach(function (it) {
      if (geschenkVon[it.variant_id]) return;
      stueck[it.product_id] = (stueck[it.product_id] || 0) + it.quantity;
    });
    var soll = {};
    Object.keys(REGELN).forEach(function (pid) {
      var n = stueck[pid] || 0, beste = null;
      REGELN[pid].forEach(function (stufe) { if (n >= stufe[0]) beste = stufe; });
      if (beste) beste[1].forEach(function (g) { soll[g[0]] = (soll[g[0]] || 0) + g[1]; });
    });
    return soll;
  }

  function abgleichen() {
    if (!Object.keys(REGELN).length) return Promise.resolve();
    if (laeuft) { nochmal = true; return Promise.resolve(); }
    laeuft = true;
    return holen('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (wk) {
        var soll = sollGeschenke(wk.items);
        var ist = {};
        wk.items.forEach(function (it) {
          var k = geschenkVon[it.variant_id];
          if (k) (ist[k] = ist[k] || []).push(it);
        });
        var updates = {}, hinzu = [], aendern = false;
        Object.keys(GESCHENKE).forEach(function (k) {
          var rest = soll[k] || 0;
          (ist[k] || []).forEach(function (zeile) {
            var menge = Math.min(zeile.quantity, rest);
            rest -= menge;
            if (menge !== zeile.quantity) { updates[zeile.key] = menge; aendern = true; }
          });
          if (rest > 0) {
            var v = (ist[k] && ist[k][0]) ? ist[k][0].variant_id : GESCHENKE[k].v[0];
            hinzu.push({ id: v, quantity: rest, properties: { _mlys_geschenk: GESCHENKE[k].name } });
          }
        });
        if (!aendern && !hinzu.length) return;
        var kette = Promise.resolve(null);
        if (aendern) kette = kette.then(function () { return post('/cart/update.js', { updates: updates }, !hinzu.length); });
        if (hinzu.length) {
          kette = kette.then(function () { return post('/cart/add.js', { items: hinzu }, true); });
          setTimeout(abgleichen, 1500); /* Nachkontrolle wie in mlys-gratis-beutel.js (Seitenwechsel waehrend des Einlegens) */
        }
        return kette.then(function (a) { if (a && !a.status) zeichnen(a, false); });
      })
      .catch(function () {})
      .then(function () {
        laeuft = false;
        if (nochmal) { nochmal = false; return abgleichen(); }
      });
  }
  window.mlysBundlesAbgleich = abgleichen;

  /* Nach jeder fremden Warenkorb-Aenderung abgleichen (eigene Anfragen tragen X-Mlys-Bundles) */
  window.fetch = function (ziel, opt) {
    var p = holen.apply(window, arguments);
    var adr = ziel && ziel.url ? ziel.url : ziel;
    var eigen = opt && opt.headers && opt.headers['X-Mlys-Bundles'];
    if (!eigen && typeof adr === 'string' && /\/cart\/(add|change|update|clear)/.test(adr)) {
      p.then(function () { setTimeout(abgleichen, 150); }).catch(function () {});
    }
    return p;
  };

  /* ---------- Zahlen (Ersatz für Rapis Auswertung): Kaufbox gesehen, Karte eingelegt. Nur im Live-Theme. ---------- */
  var ZAEHLER = 'https://script.google.com/macros/s/AKfycbyA_US3KKXSav2OKKqPaG5VKsThB88F8G218suiDqUn7EGshgpbI23iX5ixBQsxsonT/exec';
  function zaehlen(daten) {
    try {
      if (!window.Shopify || !Shopify.theme || Shopify.theme.role !== 'main' || Shopify.designMode || !navigator.sendBeacon) return;
      navigator.sendBeacon(ZAEHLER, new Blob([JSON.stringify(daten)], { type: 'text/plain' }));
    } catch (e) {}
  }

  /* ---------- 1. Kaufbox ---------- */
  function kaufbox(box) {
    var karten;
    try { karten = JSON.parse(box.querySelector('[data-karten]').textContent); } catch (e) { return; }
    var form = document.getElementById(box.getAttribute('data-form'));
    if (!form) return;
    var handle = box.getAttribute('data-handle');
    /* wie Rapi: ein Besucher pro Produkt und Tag (nur ein Datum im Browser, keine Kennung) */
    if (handle) (window.requestIdleCallback || setTimeout)(function () {
      var tag = new Date().toISOString().slice(0, 10), key = 'mbz_' + handle;
      try { if (localStorage.getItem(key) === tag) return; localStorage.setItem(key, tag); } catch (e) {}
      zaehlen({ e: 'v', p: handle });
    });
    var fehler = box.querySelector('[data-fehler]');
    if (!box.querySelector('.mb-r:checked')) { var r0 = box.querySelector('.mb-r'); if (r0) r0.checked = true; }

    if (box.mbMark) box.mbMark(); /* Auswahl-Rahmen: Skript im Snippet mlys-bundles */

    function auswahl() {
      var r = box.querySelector('.mb-r:checked');
      if (!r) return null;
      var i = +r.value, label = r.closest('.mb-k'), karte = karten[i], items = [];
      if (karte.a === 'm') {
        var plan = form.querySelector('[name="selling_plan"]');
        var proStueck = {};
        var felder = label.querySelectorAll('select[data-einheit]');
        if (felder.length) {
          felder.forEach(function (s) { proStueck[s.value] = (proStueck[s.value] || 0) + 1; });
        } else {
          var idFeld = form.querySelector('[name="id"]');
          proStueck[idFeld.value] = karte.m;
        }
        Object.keys(proStueck).forEach(function (v) {
          var it = { id: +v, quantity: proStueck[v], properties: { _mlys_bundle: karte.t } };
          if (plan && plan.value && karte.m === 1) it.selling_plan = +plan.value;
          items.push(it);
        });
        label.querySelectorAll('[data-geschenk]').forEach(function (g) {
          items.push({ id: +g.value, quantity: +g.getAttribute('data-menge'), properties: { _mlys_geschenk: karte.t } });
        });
      } else {
        var varianten = JSON.parse(label.querySelector('[data-varianten]').textContent);
        var wahl = [];
        label.querySelectorAll('select[data-option]').forEach(function (s) { wahl[+s.getAttribute('data-option')] = s.value; });
        var treffer = varianten.filter(function (v) {
          return v.a && wahl.every(function (w, j) { return w === undefined || v.o[j] === w; });
        })[0];
        if (!treffer) return { fehler: 'Diese Kombination ist gerade ausverkauft.' };
        items.push({ id: treffer.id, quantity: 1, properties: { _mlys_bundle: karte.t } });
      }
      return { items: items };
    }

    /* Dokument-Capture: laeuft sicher vor Dawns product-form (Listener direkt am Formular) */
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var knopf = form.querySelector('[type="submit"]');
      var a = auswahl();
      fehler.hidden = true;
      if (!a) return;
      if (a.fehler) { fehler.textContent = a.fehler; fehler.hidden = false; return; }
      if (knopf) { knopf.setAttribute('aria-disabled', 'true'); knopf.classList.add('loading'); }
      post('/cart/add.js', { items: a.items }, true)
        .then(function (antwort) {
          if (antwort.status) {
            fehler.textContent = antwort.description || 'Das hat nicht geklappt. Bitte versuch es nochmal.';
            fehler.hidden = false;
            return;
          }
          var gewaehlt = box.querySelector('.mb-r:checked');
          if (handle && gewaehlt && karten[+gewaehlt.value]) zaehlen({ e: 'a', p: handle, k: karten[+gewaehlt.value].t });
          if (document.querySelector('cart-drawer')) zeichnen(antwort, true);
          else window.location.href = '/cart';
          setTimeout(abgleichen, 300);
        })
        .catch(function () { fehler.textContent = 'Das hat nicht geklappt. Bitte versuch es nochmal.'; fehler.hidden = false; })
        .then(function () { if (knopf) { knopf.removeAttribute('aria-disabled'); knopf.classList.remove('loading'); } });
    }, true);
  }

  function start() {
    document.querySelectorAll('[data-mb]').forEach(kaufbox);
    abgleichen();
    setTimeout(abgleichen, 3000); /* Nachkontrolle: Einlegen der vorigen Seite kann noch unterwegs sein */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
